import React, { Component, PropTypes } from 'react';
import update from 'react-addons-update';
import { canUseDOM } from 'exenv';

import classnames from 'classnames';

import MobileLocationMenu from './menus/MobileLocationMenu';
import DesktopLocationMenu from './menus/DesktopLocationMenu';
import FavoritesMenu from './menus/FavoritesMenu';
import AccountMenu from './menus/AccountMenu';
import PaymentWarningBanner from '../PaymentWarningBanner/PaymentWarningBanner';
import Button, { TYPE } from '../Button/Button';

import config from '../../config';
import { signInUrl } from '../../utils/urls/signInUrl';
import logo from '../../public/logo.png';
import PremiumBanner from '../PremiumBanner/PremiumBanner';


const navHeight = 60; // px
const sideNavWidth = 80; // px

class GlobalHeader extends Component {

  static propTypes = {
    userId: PropTypes.string,
    locations: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    doClickedSubscribeCTA: PropTypes.func.isRequired,
    doTrackEvent: PropTypes.func.isRequired,
    isFullscreenPage: PropTypes.bool,
  }

  constructor(props) {
    super(props);

    this.locations = props.locations;
    // this.user = props.user || this.reloadUserData();
    this.user = props.user;
    this.config = config;
    this.analytics = this.props.analytics;

    this.state = {
      userId: props.userId,
      favorites: this.props.favorites || this.props.user.favorites,
      menu: {
        mobileOpen: false,
      },
      dim: {
        height: navHeight,
        secondaryWidth: 0,
      },
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState(update(this.state, {
      favorites: { $set: nextProps.favorites },
    }));
  }

  // reloadUserData() {
  //   if (canUseDOM && window.user_settings) {
  //     this.user = window.user_settings;
  //   }
  //   return this.user;
  // }

  closeMenu() {
    this.setState(update(this.state,
      { $set: { menu: {
        mobileOpen: false,
      },
        dim: {
          height: navHeight,
          secondaryWidth: 0,
        } } },
    ));
    this.body.style.display = 'block';
  }

  toggleMenu() {
    this.setState(update(this.state,
      { $set: { menu: {
        mobileOpen: !this.state.menu.mobileOpen,
        activeSubMenu: <FavoritesMenu favorites={this.state.favorites} user={this.user} mobile doTrackEvent={this.props.doTrackEvent} />,
        activeRef: 'favoritesMenu',
      } } },
    ));

    if (!this.state.menu.mobileOpen) { // the menu is open after the state has changed
      this.sizeMenu();
    }

    this.body.style.display = !this.state.menu.mobileOpen ? 'none' : 'block';
  }

  componentDidMount() {
    this.body = document.getElementById('main');
  }

  componentWillUnmount() {
  }

  sizeMenu() {
    this.setState(update(this.state,
      { $set: { dim: {
        secondaryWidth: window.innerWidth - sideNavWidth,
        height: window.innerHeight,
      } } },
    ));
  }

  closeDesktopMenu() {
    this.setState(update(this.state,
      { $set: { menu: {} } },
    ));
  }

  /**
   * Available menus
   *  - locationMenu
   *  - favoritesMenu
   *  - supportMenu
   *  - accountMenu
   *
   */
  loadMenu(menu, component) {
    if (!this.state.menu.mobileOpen) { // this is a good way to check if a desktop menu is open
      if (menu === this.state.menu.activeRef) { // close menu
        this.closeDesktopMenu();
        event.preventDefault();
        return;
      }

      document.addEventListener('click', (event) => {
        const eventTag = event.target.tagName.toLowerCase();
        const whitelist = ['i', 'a', 'span'];

        if (whitelist.indexOf(eventTag) < 0) {
          this.closeDesktopMenu();
          event.preventDefault();
        }
      }, false);
    }

    this.setState(update(this.state,
      { $set: { menu: {
        mobileOpen: this.state.menu.mobileOpen,
        activeSubMenu: component,
        activeRef: menu,
      } } },
    ));

    event.preventDefault();
  }

  getMenuClasses(menu) {
    return (menu === this.state.menu.activeRef) ? 'dropdown-toggle active' : 'dropdown-toggle';
  }

  getOpen(menu) {
    return (menu === this.state.menu.activeRef) ? 'dropdown active' : 'dropdown';
  }

  exitLink(path) {
    const destination = canUseDOM ? window.location.pathname : '/';
    return `${path}?destination=${destination}`;
  }

  clickedTryPremium = () => {
    const {
      doClickedSubscribeCTA,
    } = this.props;
    doClickedSubscribeCTA({
      ctaLocation: 'navigational header',
    });
    window.location.href = this.config.links.funnel.try_premium;
  }

  clickedSignIn = () => {
    const { pathname, search, hash } = window.location;
    window.location.href = signInUrl(
      this.config.links.funnel.login,
      `${pathname}${search}${hash}`,
    );
  }

  clickedRenew = () => { window.location.href = this.config.links.funnel.registerNow; }

  clickedHome = () => {
    window.location.href = '/';
  }

  render() {
    const navClasses = classnames({
      'navbar-collapse': true,
      'collapse.in': this.state.menu.mobileOpen,
      collapse: !this.state.menu.mobileOpen,
    });

    const headerClasses = classnames({
      navbar: true,
      'navbar-fixed-top': !this.props.isFullscreenPage,
      'navbar-standard': this.props.isFullscreenPage,
    });

    const hamburgerClasses = classnames({
      'icon-menu': !this.state.menu.mobileOpen,
      'icon-close': this.state.menu.mobileOpen,
      hamburger: true,
    });

    const {
      doTrackEvent,
    } = this.props;

    return (
      <div className="container-fluid">
        <header className={headerClasses} id="top" role="banner">
          <div className="container">
            <div className="navbar-header">
              <button
                onClick={this.toggleMenu.bind(this)}
                type="button"
                className="navbar-toggle collapsed"
              >
                <span className="sr-only">Toggle navigation</span>
                <i className={hamburgerClasses} />
              </button>
              <a onClick={this.clickedHome} href="/">
                <img className="brand logo" src={logo} alt="Buoyweather" />
              </a>
              {this.user.type !== 'premium' && (
                <button className="btn btn-new btn-premium btn-medium navbar-header__premium-button" onClick={this.clickedTryPremium}>Try Premium for free</button>
              )}
              {this.user.type !== 'premium' && <PremiumBanner clickedTryPremium={this.clickedTryPremium} />}
            </div>
            <div className="nav-menu-container">
              <nav
                className={navClasses}
                style={{ height: this.state.dim.height }} ref="navContainer"
              >
                <ul
                  className="nav navbar-nav"
                  ref="navTopLevel"
                  style={{ height: this.state.dim.height }}
                >
                  {(() => {
                    if (this.state.userId || (this.state.menu.mobileOpen)) {
                      return (
                        <li className={this.getOpen('favoritesMenu')}>
                          <a
                            href="#" ref="favoritesMenu"
                            className={this.getMenuClasses('favoritesMenu')}
                            onClick={this.loadMenu.bind(this, 'favoritesMenu', <FavoritesMenu favorites={this.state.favorites} mobile user={this.user} doTrackEvent={doTrackEvent} />)}
                          >
                            Favorites
                          </a>
                          {/* <MenuCaret activeMenu={this.state.menu.activeRef} menu="favoritesMenu" /> */}
                          <FavoritesMenu favorites={this.state.favorites} user={this.user} openRef={this.state.menu.activeRef} doTrackEvent={doTrackEvent} />
                        </li>
                      );
                    }
                  })()}
                  <li className={`${this.getOpen('locationMenu')} locationMenu`}>
                    <a
                      href="#" ref="locationMenu"
                      className={this.getMenuClasses('locationMenu')}
                      onClick={this.loadMenu.bind(this, 'locationMenu', <MobileLocationMenu locations={this.locations} mobile closeMenu={this.closeMenu.bind(this)} doTrackEvent={doTrackEvent} />)}
                    >
                      Locations
                    </a>
                    {/* <MenuCaret activeMenu={this.state.menu.activeRef} menu="locationMenu" /> */}
                    <DesktopLocationMenu locations={this.locations} openRef={this.state.menu.activeRef} doTrackEvent={doTrackEvent} />
                  </li>
                  {(() => {
                    if (this.state.userId && this.state.userId) {
                      return (
                        <li className={this.getOpen('accountMenu')}>
                          <a
                            href="#" ref="accountMenu"
                            className={this.getMenuClasses('accountMenu')}
                            onClick={this.loadMenu.bind(this, 'accountMenu', <AccountMenu mobile user={this.user} />)}
                          >
                            Account
                          </a>
                          {/* <MenuCaret activeMenu={this.state.menu.activeRef} menu="accountMenu" /> */}
                          <AccountMenu openRef={this.state.menu.activeRef} user={this.user} />
                        </li>
                      );
                    }
                  })()}
                </ul>
                <div
                  id="mobile-menu" ref="navSecondary"
                >
                  <div
                    className="mobile-menu-container"
                    style={{ height: (this.state.dim.height - 65) }}
                  >
                    {(() => this.state.menu.activeSubMenu)()}
                  </div>
                </div>
                { this.user.type === 'registered' ?
                  <Button
                    className="desktop-header-btn"
                    type={TYPE.premium}
                    onClick={this.clickedTryPremium}
                  >
                    Try Premium for free
                  </Button> : null
                }
                { this.user.type === 'expired' ?
                  <Button
                    className="desktop-header-btn"
                    type={TYPE.premium}
                    onClick={this.clickedRenew}
                  >
                    Renew Membership Now
                  </Button> : null
                }
                { this.user.type === 'non-registered' ?
                  <div className="desktop-header-btn">
                    <Button
                      type={TYPE.default}
                      onClick={this.clickedSignIn}
                    >
                      Sign In
                    </Button>
                    <Button
                      type={TYPE.premium}
                      onClick={this.clickedTryPremium}
                    >
                      Try Premium for free
                    </Button>
                  </div> : null
                }
              </nav>
            </div>
          </div>
        </header>
      </div>
    );
  }
}

GlobalHeader.defaultProps = {
  user: {
    user_id: -1,
    ip: '0.0.0.0',
    favorites: [],
    units: 'e',
    type: 'non-registered',
  },
};


class MenuCaret extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const menus = classnames({
      fa: true,
      'fa-caret-up': true,
      active: this.props.menu === this.props.activeMenu,
    });

    return (
      <span className="caret-holder"><i className={menus} /></span>
    );
  }
}

export default GlobalHeader;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/GlobalHeader.js